var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { NOT_LOADED } from "../Infra/RemoteData";
import { StudyTranslationLanguage } from "healthex-common/study-translation-language.dtos";
import { NamedRoutes } from "./NamedRoutes";
import { PatientConsentExcludedReason } from "./PatientConsentUIManager";
import { getObservableT } from "../Infra/i18next";
const t = getObservableT("patients");
export class PatientConsentExcludedViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.browserLanguageUIManager = container.browserLanguageUIManager;
        this.routingUIManager = container.routingUIManager;
    }
    get excludedReason() {
        return this.patientConsentUIManager.excludedReason;
    }
    get studyContactInfoString() {
        if (this.study === NOT_LOADED || this.study === null)
            return "";
        let text = "";
        if (this.study.sitePrimaryContactName) {
            text = this.study.sitePrimaryContactName;
        }
        const contactMethods = [];
        if (this.study.sitePrimaryContactEmail) {
            contactMethods.push(this.study.sitePrimaryContactEmail);
        }
        if (this.study.sitePrimaryContactPhone) {
            contactMethods.push(this.study.sitePrimaryContactPhone);
        }
        if (this.study.sitePrimaryContactLink) {
            contactMethods.push(this.study.sitePrimaryContactLink);
        }
        if (contactMethods.length > 0) {
            text += `, ${contactMethods.join("/")}`;
        }
        return text;
    }
    get confirmButtonText() {
        switch (this.excludedReason) {
            case PatientConsentExcludedReason.UNDERAGE:
                return t("Learn more about HealthEx");
            case PatientConsentExcludedReason.NOT_RECRUITING:
                return this.healthWalletExitButtonText;
            default:
                return this.healthWalletExitButtonText;
        }
    }
    continueInEnglish() {
        this.browserLanguageUIManager.setInMemoryLanguage(StudyTranslationLanguage.en);
        this.patientConsentUIManager.startFromBeginning();
    }
    onConfirmButtonClicked() {
        switch (this.excludedReason) {
            case PatientConsentExcludedReason.UNDERAGE:
                window.open("https://healthex.io/patients", "_blank", "noopener,noreferrer");
                break;
            case PatientConsentExcludedReason.NOT_RECRUITING:
                this.goToHealthEx();
                break;
            default:
                this.goToHealthEx();
                break;
        }
    }
    goToHealthEx() {
        if (this.isPatientLoggedIn) {
            this.routingUIManager.navigateTo(this.isHealthWalletEnabledForNavigation ? NamedRoutes.PATIENT_RECORDS : NamedRoutes.PATIENT_SHARING);
        }
        else {
            this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_PATIENT);
        }
    }
}
__decorate([
    computed
], PatientConsentExcludedViewModel.prototype, "excludedReason", null);
__decorate([
    computed
], PatientConsentExcludedViewModel.prototype, "studyContactInfoString", null);
__decorate([
    computed
], PatientConsentExcludedViewModel.prototype, "confirmButtonText", null);
